var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 26H45.25C46.7688 26 48 27.2312 48 28.75V34.25C48 35.7688 46.7688 37 45.25 37H34.25C31.2124 37 28.75 34.5376 28.75 31.5C28.75 28.4624 31.2124 26 34.25 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 15H39.75L28.75 5.375L23.25 9.5L28.75 15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 15H28.75L23.25 9.5L17.75 4L6.75 15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.75V45.25C4 46.7688 5.23122 48 6.75 48H39.75C41.2688 48 42.5 46.7688 42.5 45.25V38C42.5 37.4477 42.0523 37 41.5 37H34.25C31.2124 37 28.75 34.5376 28.75 31.5C28.75 28.4624 31.2124 26 34.25 26H41.5C42.0523 26 42.5 25.5523 42.5 25V17.75C42.5 16.2312 41.2688 15 39.75 15H28.75H6.75C5.23122 15 4 16.2312 4 17.75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 15H6.75M39.75 15C41.2688 15 42.5 16.2312 42.5 17.75V25C42.5 25.5523 42.0523 26 41.5 26H34.25M39.75 15L28.75 5.375L23.25 9.5M39.75 15H28.75M6.75 15C5.23122 15 4 16.2312 4 17.75V45.25C4 46.7688 5.23122 48 6.75 48H39.75C41.2688 48 42.5 46.7688 42.5 45.25V38C42.5 37.4477 42.0523 37 41.5 37H34.25M6.75 15L17.75 4M6.75 15H28.75M28.75 15C27.0999 13.3499 25.0944 11.3444 23.25 9.5M28.75 15L23.25 9.5M17.75 4C17.75 4 20.2929 6.54291 23.25 9.5M17.75 4L23.25 9.5M34.25 26H45.25C46.7688 26 48 27.2312 48 28.75V34.25C48 35.7688 46.7688 37 45.25 37H34.25M34.25 26C31.2124 26 28.75 28.4624 28.75 31.5C28.75 34.5376 31.2124 37 34.25 37",
    stroke: "#7CA324",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.cc8c3a5dd1406824f73d7153ee7c0c71.svg";
export { ForwardRef as ReactComponent };